module.exports = __webpack_public_path__ + "./Verna2_2e9e92b38dd1f9bb5ede68890cd2f099.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2022/Verna2.png
// module id = 579
// module chunks = 0